import config from "../config/config";
import { apiConfig } from "../config/apiConfig";
import ApiService from "./apiService";

class ClientCounterPartyService {
    static instance;

    constructor () {
        if (!ClientCounterPartyService.instance) {
            this.instance = this;
            this.baseUrl = config['backend-url'].endsWith('/') ? config['backend-url'].slice(0, -1) : config['backend-url'];
            this.useToken = true;
            this.dontUseToken = false;
            this.apiService = new ApiService(this.baseUrl);
        }
        return ClientCounterPartyService.instance;
    }

    async fetchEntityByRequestId ( requestId ) {
        const response = await this.apiService.post(
            apiConfig.clientCounterparty.getEntityByRequestId,
            { requestId },
            this.useToken
        );
        const data = response.data;
        if (response.ok) {
            return data.entityid || []; // Return property IDs or an empty array
        } else {
            console.error("Failed to fetch properties:", data);
            throw new Error(data.message || "Failed to fetch properties");
        }
    }

    async getDiligenceType ( companyType, country ) {
        const response = await this.apiService.post(
            apiConfig.clientCounterparty.getDeligenceType,
            {
                country: country,
                CompanyType: companyType
            },
            this.useToken
        );

        const data = response.data;

        if (response.ok) {
            if (data.length > 0) {
                return data[0].Diligence;
            } else {
                return null
            }
        } else {
            console.error(`Error when fetching DiligenceType: ${response}`);
            return null;
        }
    }

    async getDiligenceTypeByCountry ( country ) {
        const response = await this.apiService.post(
            apiConfig.clientCounterparty.getDeligenceType,
            { country: country },
            this.useToken
        );

        const data = response.data;

        if (response.ok) {
            if (data.length > 0) {
                return data;
            } else {
                return null
            }
        } else {
            console.error(`Error when fetching DiligenceType: ${response}`);
            return null;
        }
    }

    async updateEntity (requestId, payload) {
        const response = await this.apiService.post(
            apiConfig.clientCounterparty.addEntity,
            { requestId, payload },
            this.useToken
        )
        
        if (response.ok) {
            console.log("UpdateEntiy Success", response.data);
            return response
        } else {
            console.log("Update Entity Error: ", response);
            return response
        }
    }

    async fetchEntityDetailsByEntityId (entityID) {
        const response = await this.apiService.post(
            apiConfig.clientCounterparty.getEntityDetailsByEntityId,
            { entity_id: entityID },
            this.useToken
        )

        const data = response.data;

        if (response.ok) {
            return data
        } else {
            return null;
        }
    }

    async fetchQuickEntityDetailsByEntityId(entityID) {
        try {
            const response = await this.apiService.post(
                apiConfig.clientCounterparty.getQuickEntityDetailsByEntityId,
                { entity_id: entityID },
                this.useToken
            );
    
            const data = response.data;
    
            if (response.ok) {
                return data;
            } else {
                console.error("⚠️ API responded with error status:", response.status, data);
                return null;
            }
        } catch (error) {
            console.error("❌ Error fetching quick entity details:", error.message || error);
            return null;
        }
    }

}

export const clientCoutnerpartyService = new ClientCounterPartyService();